"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const libs_polyfills_1 = require("@hotelplan/libs.polyfills");
function useOnClickOutside(refOrRefs, handler, isListening = true) {
    (0, react_1.useEffect)(() => {
        if (!refOrRefs || !isListening) {
            return;
        }
        const listener = (event) => {
            const refsArray = Array.isArray(refOrRefs)
                ? refOrRefs
                : [refOrRefs];
            // Do nothing if clicking ref's element or descendent elements
            if (refsArray.find(ref => !ref.current || ref.current.contains(event.target))) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener, libs_polyfills_1.optionsWithPassive);
        document.addEventListener('touchstart', listener, libs_polyfills_1.optionsWithPassive);
        return function cleanupListeners() {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
        // ... passing it into this hook.
        // ... but to optimize you can wrap handler in useCallback before ...
        // ... callback/cleanup to run every render. It's not a big deal ...
        // ... function on every render that will cause this effect ...
        // It's worth noting that because passed in handler is a new ...
        // Add ref and handler to effect dependencies
    }, [refOrRefs, handler, isListening]);
}
exports.default = useOnClickOutside;
//# sourceMappingURL=useOnClickOutside.js.map